import {
  errorToastClassName,
  sonnerToast,
  successToastClassName,
  appToast as toast,
} from "@/components/ui/baseUi/sonner"
import {
  type CouponInputFormik,
  couponYupValidation,
  DurationType,
} from "@modules/boxSubscription/formik/boxSubscriptionFormik"
import { CouponType } from "@modules/common/couponObject/gateway/couponObjectApiDto"
import { word } from "@modules/core/utils/i18n"
import { ProgramBundleSubscriberEntity } from "@modules/programBundle/programBundleSubscribers/entities/programBundleSubscriberEntity"
import { ProgramSubscriberEntity } from "@modules/programs/programSubscriber/entities/programSubscriberEntity"
import { useProgramSubscriberActions } from "@modules/programs/programSubscriber/hooks/useProgramSubscriber"
import { useFormik } from "formik"
import { useState } from "react"

export function useSubscriberDiscountFormik(
  programId: string,
  subscriberDetails: ProgramSubscriberEntity | ProgramBundleSubscriberEntity,
  moveToSubscriberDetails: () => void,
) {
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { applySubscriptionDiscount } = useProgramSubscriberActions(programId, subscriberDetails)

  const onSubmitForm = () => {
    setIsSubmitting(true)
    sonnerToast.promise(
      applySubscriptionDiscount(formik.values)
        .then(() => {
          toast.success(word("program.subscribers.subscriptionDetails.discount.success"), {
            classNames: successToastClassName(),
          })
          moveToSubscriberDetails()
        })
        .catch(() => {
          toast.error(word("global.error.label"), {
            classNames: errorToastClassName(),
          })
        })
        .finally(() => {
          setIsSubmitting(false)
        }),
    )
  }

  const formik = useFormik<CouponInputFormik>({
    enableReinitialize: true,
    initialValues: { type: CouponType.PERCENT, value: 0, durationType: DurationType.UNLIMITED, months: null },
    validationSchema: couponYupValidation({
      priceOffer: subscriberDetails.paidPrice?.value ?? 0,
    }),
    onSubmit: onSubmitForm,
  })

  return { formik, isSubmitting }
}
